module.exports = "/_next/static/images/78197ace6c5fed98fffa95f275d56ce8-phone-icon.svg";